import { z } from 'zod';
import { ATTRIBUTE_KEYS } from '../characterAttributes';

// ============================================
// 六维属性键 Schema
// ============================================

export type { AttributeDefinition, AttributeKey } from '../characterAttributes';

export const AttributeKeySchema = z.enum(ATTRIBUTE_KEYS);
